import * as angular from 'angular';
import permissions from 'application/detail/permissions.json';
import 'angular-ui-router';
import shared from 'modules/shared';
//Views
import Faq2ContentView from './Faq2ContentView.html';
import Faq2FeedbackView from './Faq2FeedbackView.html';
import Faq2MenuView from './Faq2MenuView.html';
//Controllers
import { Faq2Controller } from './Faq2Controller';
//
export default angular
    .module('templates.faq2', ['ui.router', shared])
    .controller('Faq2Controller', Faq2Controller)
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state('auth.application.detail.faq2', {
            url: '/template/faq2',
            redirectTo: 'auth.application.detail.faq2.index',
            data: {
                permissionClaim: permissions.basicConfigurations.claim,
            },
            views: {
                'sidenav@auth.application.detail': {
                    template: Faq2MenuView,
                },
            },
        })
            .state('auth.application.detail.faq2.index', {
            url: '/index',
            views: {
                'content@auth.application.detail': {
                    template: Faq2FeedbackView,
                    controller: Faq2Controller,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.basicConfigurations.claim,
            },
        })
            .state('auth.application.detail.faq2.reliability', {
            url: '/feedback',
            views: {
                'content@auth.application.detail': {
                    template: Faq2ContentView,
                    controller: Faq2Controller,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.basicConfigurations.claim,
            },
        });
    }]).name;
